import { z } from "zod";

import { sentryConfigSchema } from "udzs-common/schema";

export const envSchema = z
  .object({
    VITE_BASENAME: z.string(),
    VITE_API_BASE_PATH: z.string(),
    VITE_AUTH_ISSUER: z.string(),
    VITE_PIP_APP_URL: z.string(),
  })
  .extend({
    VITE_ENVIRONMENT_LABEL: z.string().default(""),
    VITE_TEST_SCENARIOS_ENABLED: z
      .enum(["true", "false"])
      .default("false")
      .transform((value) => value === "true"),
  })
  .merge(sentryConfigSchema);
